module.exports = __webpack_public_path__ + "static/media/block-osu-darkmode.70359b57.svg";